import React, { useState, useRef, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { IoVolumeMute, IoVolumeHigh } from 'react-icons/io5';

import '../style/reelgrid.css';

import reel1 from '../../assets/reels/vfx & hyperlaspe/Boc 2.mp4';
import reel2 from '../../assets/reels/vfx & hyperlaspe/Factory Star 3.mp4';
import reel3 from '../../assets/reels/vfx & hyperlaspe/Faizaia Society.mp4';
import reel4 from '../../assets/reels/vfx & hyperlaspe/Fashion Shoes (1).mp4';
import reel5 from '../../assets/reels/vfx & hyperlaspe/Jab Chaho.mp4';
import reel6 from '../../assets/reels/vfx & hyperlaspe/Jumbo Ae.mp4';
import reel7 from '../../assets/reels/vfx & hyperlaspe/Metro.mp4';
import reel8 from '../../assets/reels/vfx & hyperlaspe/Sould Fst Lhr.mp4';
import reel9 from '../../assets/reels/speed ramping/Flitta2 Reel Full.mp4';
import reel10 from '../../assets/reels/speed ramping/Ideas Outlet.mp4';
import reel11 from '../../assets/reels/speed ramping/The Art Of Speed.mp4';
import reel12 from '../../assets/reels/speed ramping/Omnomfries.mp4';





// Sample video data - 12 reels matching your grid
const reelData = [
  { id: 1, url: reel1 },
  { id: 2, url: reel2 },
  { id: 3, url: reel3 },
  { id: 4, url: reel4 },
  { id: 5, url: reel5 },
  { id: 6, url: reel6 },
  { id: 7, url: reel7 },
  { id: 8, url: reel8 },
  { id: 9, url: reel9 },
  { id: 10, url: reel10 },
  { id: 11, url: reel11 },
  { id: 12, url: reel12 },
];

// Individual Reel Card Component
const ReelCard = ({ reel, className }) => {
  const [isMuted, setIsMuted] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const videoRef = useRef(null);
  
  const { ref, inView } = useInView({
    threshold: 0.5,
    triggerOnce: false,
  });

  // Auto-play/pause based on visibility
  useEffect(() => {
    if (videoRef.current) {
      if (inView) {
        videoRef.current.play().catch(() => {});
      } else {
        videoRef.current.pause();
      }
    }
  }, [inView]);

  const toggleMute = (e) => {
    e.stopPropagation();
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  const handleVideoLoad = () => {
    setIsLoading(false);
  };

  return (
    <div className={`reel-card ${className}`} ref={ref}>
      {/* Loading skeleton */}
      {isLoading && <div className="reel-skeleton"></div>}
      
      {/* Video element */}
      <video
        ref={videoRef}
        src={reel.url}
        muted={isMuted}
        loop
        playsInline
        className="reel-video"
        onLoadedData={handleVideoLoad}
      />

      {/* Mute toggle button */}
      <button 
        className="mute-button"
        onClick={toggleMute}
        aria-label={isMuted ? 'Unmute' : 'Mute'}
      >
        {isMuted ? <IoVolumeMute size={18} /> : <IoVolumeHigh size={18} />}
      </button>
    </div>
  );
};

// Main Masonry Grid Component with explicit placement
const ReelGrid = () => {
  return (
    <div className="reel-grid-container">
      <div className="reel-grid">
        {/* Column 1 - Starts lower (2 reels) */}
        <ReelCard reel={reelData[0]} className="reel-1" />
        <ReelCard reel={reelData[1]} className="reel-2" />
        
        {/* Column 2 - Starts higher (3 reels) */}
        <ReelCard reel={reelData[2]} className="reel-3" />
        <ReelCard reel={reelData[3]} className="reel-4" />
        <ReelCard reel={reelData[4]} className="reel-5" />
        
        {/* Column 3 - Starts lower (2 reels) */}
        <ReelCard reel={reelData[5]} className="reel-6" />
        <ReelCard reel={reelData[6]} className="reel-7" />
        
        {/* Column 4 - Starts higher (3 reels) */}
        <ReelCard reel={reelData[7]} className="reel-8" />
        <ReelCard reel={reelData[8]} className="reel-9" />
        <ReelCard reel={reelData[9]} className="reel-10" />
        
        {/* Column 5 - Starts lower (2 reels) */}
        <ReelCard reel={reelData[10]} className="reel-11" />
        <ReelCard reel={reelData[11]} className="reel-12" />
      </div>
    </div>
  );
};

export default ReelGrid;